import React from "react";
import Image from "next/image";
import LogoM from "@/assets/images/logom.png";
import styles from "@/styles/houseOfSenco.module.scss";
import { Spinner } from "react-bootstrap";
import { useAppDispatch } from "@/store";
import { useSelector } from "react-redux";
import { authActions, selectAuth } from "@/store/slices/auth";
import Button from "react-bootstrap/Button";
import Container from "react-bootstrap/Container";
import Form from "react-bootstrap/Form";
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";
import NavDropdown from "react-bootstrap/NavDropdown";
import Link from "next/link";
import moment from "moment-timezone";

const MobileHeader = () => {
  const dispatch = useAppDispatch();
  const authState = useSelector(selectAuth);
  moment.tz.setDefault("Asia/Kolkata");
  const currentDate = moment();
  const startDate = moment("2024-12-21", "YYYY-MM-DD").startOf("day");

  return (
    <header className={styles.mobile_header}>
      <div className={styles.logo_mobile}>
        <Image src={LogoM} alt="logo" />
      </div>
      {/* <div className={styles.mobile_list_container}>
        <div className={styles.container}>
          <div className={styles.mobile_list}>
            <ul> */}
      {/* <li>
                <a>
                  <Image
                    className="img-fluid pointer"
                    src={require("@/assets/images/wishlist.svg")}
                    alt="Wishlist"
                    width={29}
                    height={29}
                    priority
                    unoptimized
                  />
                </a>
              </li>
              <li>
                <a>
                  <Image
                    className="img-fluid pointer"
                    src={require("@/assets/images/cart.svg")}
                    alt="Cart"
                    priority
                    unoptimized
                    width={29}
                    height={29}
                  />
                </a>
              </li> */}
      {/* {authState.user ? (
                <li>
                  <Link style={{ cursor: "pointer" }} href={"/account/profile"}>
                    <Image
                      className="img-fluid pointer"
                      src={require("@/assets/images/account.svg")}
                      width={29}
                      height={29}
                      alt="Account"
                      priority
                      unoptimized
                    />
                  </Link>
                </li>
              ) : (
                <li>
                  {authState.isUserLoading ? (
                    <Spinner animation="border" size="sm" />
                  ) : (
                    <a
                      style={{ cursor: "pointer" }}
                      onClick={() => {
                        dispatch(authActions.setIsModalOpen(true));
                      }}
                    >
                      <Image
                        className="img-fluid pointer"
                        src={require("@/assets/images/account.svg")}
                        width={29}
                        height={29}
                        alt="Account"
                        priority
                        unoptimized
                      />
                    </a>
                  )}
                </li>
              )} */}

      {/* <li>
                  <a>
                    <Image
                      className="img-fluid"
                      src={require("@/assets/images/searchicon.png")}
                      alt="Search icon"
                      priority
                      unoptimized
                    />
                  </a>
                </li> */}
      {/* <li>
                <a>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    x="0px"
                    y="0px"
                    width="30"
                    height="30"
                    viewBox="0 0 50 50"
                  >
                    <path d="M 0 9 L 0 11 L 50 11 L 50 9 Z M 0 24 L 0 26 L 50 26 L 50 24 Z M 0 39 L 0 41 L 50 41 L 50 39 Z"></path>
                  </svg>
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div> */}
      <div className="house-of-senco-mobile-nav">
        <Navbar expand="lg" className="bg-body-tertiary">
          <Container fluid>
            <Navbar.Brand>
              {" "}
              {authState.user ? (
                <Link
                  passHref
                  style={{ cursor: "pointer" }}
                  href={"/account/profile"}
                >
                  <Image
                    className="img-fluid pointer"
                    src={require("@/assets/images/account.svg")}
                    width={29}
                    height={29}
                    alt="Account"
                    priority
                    unoptimized
                  />
                </Link>
              ) : (
                <>
                  {authState.isUserLoading ? (
                    <Spinner animation="border" size="sm" />
                  ) : (
                    <a
                      style={{ cursor: "pointer" }}
                      onClick={() => {
                        dispatch(authActions.setIsModalOpen(true));
                      }}
                    >
                      <Image
                        className="img-fluid pointer"
                        src={require("@/assets/images/account.svg")}
                        width={29}
                        height={29}
                        alt="Account"
                        priority
                        unoptimized
                      />
                    </a>
                  )}
                </>
              )}
            </Navbar.Brand>
            <Navbar.Toggle aria-controls="navbarScroll" />
            <Navbar.Collapse id="navbarScroll">
              <Nav className="me-auto my-2 my-lg-0">
                <NavDropdown title="JEWELLERY" id="navbarScrollingDropdown">
                  <NavDropdown.Item
                    href="https://www.sennes.in/collections/lab-grown-diamonds-jewellery"
                    target="_blank"
                  >
                    Lab Grown Diamonds{" "}
                  </NavDropdown.Item>{" "}
                  <NavDropdown.Divider />
                  <NavDropdown.Item
                    href="https://sencogoldanddiamonds.com/jewellery/category/aham-collection"
                    target="_blank"
                  >
                    Aham
                  </NavDropdown.Item>
                  <NavDropdown.Divider />
                  <NavDropdown.Item
                    href="https://everlite.com/"
                    target="_blank"
                  >
                    Everlite
                  </NavDropdown.Item>
                  <NavDropdown.Divider className="mb-0" />
                </NavDropdown>
                <Nav.Link
                  href="https://www.sennes.in/category/bags-and-accessories"
                  target="_blank"
                >
                  BAGS
                </Nav.Link>
                <NavDropdown title="BRANDS" id="navbarScrollingDropdown">
                  <NavDropdown.Item
                    href="https://www.sennes.in/"
                    target="_blank"
                  >
                    Sennes
                  </NavDropdown.Item>
                  <NavDropdown.Divider />
                  <NavDropdown.Item
                    href="https://sencogoldanddiamonds.com/jewellery/category/aham-collection"
                    target="_blank"
                  >
                    Aham
                  </NavDropdown.Item>
                  <NavDropdown.Divider />

                  <NavDropdown.Item
                    href="https://everlite.com/"
                    target="_blank"
                  >
                    Everlite
                  </NavDropdown.Item>
                  <NavDropdown.Divider className="mb-0" />
                </NavDropdown>
              </Nav>
            </Navbar.Collapse>
          </Container>
        </Navbar>
      </div>
    </header>
  );
};

export default MobileHeader;
